const BASE_URL = "https://demo.zakhealth.com";

export const Constants = {
    BASE_URL,
    API: {
        STORE_RESULTS: `${BASE_URL}/api/scan-results`,
        REDUCE_SCAN_LIMIT: `${BASE_URL}/api/clients/decrement-scan`,
        VERIFY_USER: `${BASE_URL}/api/user-details`,
        VERIFY_CLIENT: `${BASE_URL}/api/verify-client`,
        LOGIN: `${BASE_URL}/api/login`,
        COUNTRIES: `${BASE_URL}/api/countries`,
        CLIENT_LOGS: `${BASE_URL}/api/client-logs`,
        COOKIE_SETTINGS: `${BASE_URL}/api/cookies-settings?group_id=7`,
    },
};
